module.exports = __webpack_public_path__ + "static/media/banner.4101c555.png";